import React from 'react';
import { products } from '../data/content';
export function Solution() {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-142" data-mp="1ekcflhlc8j3c">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-143" data-mp="1ejswhxjybonq">
        <header className="mx-auto max-w-narrow text-center" data-id="element-144" data-mp="10s4nw48wvibi">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-amber-700" data-id="element-145" data-mp="15saintah9kxt">
            La Solución
          </p>
          <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-night md:text-5xl" data-id="element-146" data-mp="qu8dxfrpmtez">
            Protocolo Septiembre Amarillo™
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-gray-600 md:text-xl" data-id="element-147" data-mp="hv3gkcrvx64e">
            Un sistema integrado de intervención profesional que funciona desde el minuto uno.
          </p>
        </header>

        <div className="mt-14 space-y-14 md:mt-16 md:space-y-20" data-id="element-148" data-mp="2c9e4mj0nnw94">
          {products.map((product, index) => <article key={product.title} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-149" data-mp="2h64h6wd949ps" data-mpi={index}>
              <div className={index % 2 === 1 ? 'lg:order-2' : ''} data-id="element-150" data-mp="2z55vlomdfwg">
                <p className="inline-flex items-center gap-2 rounded-full bg-night px-4 py-1.5 font-display text-[0.7rem] font-extrabold uppercase tracking-[0.16em] text-amber-400" data-id="element-151" data-mp="2ywvc0fyymof">
                  {product.eyebrow}
                </p>
                <h3 className="mt-5 font-display text-2xl font-extrabold leading-tight tracking-tight text-night md:text-4xl" data-id="element-152" data-mp="3k70lnvhaa1m7">
                  <span className="mr-2" aria-hidden="true" data-id="element-153" data-mp="3g6qi0pgyrnai">
                    {product.emoji}
                  </span>
                  {product.title}
                </h3>
                <p className="mt-4 font-display text-lg font-bold leading-snug text-gray-700 md:text-xl" data-id="element-154" data-mp="3p6n20dserxz8">
                  {product.lead}
                </p>
                <p className="mt-4 text-lg leading-relaxed text-gray-600" data-id="element-155" data-mp="19decgyan4wl7">{product.body}</p>
              </div>

              <div className={`space-y-5 ${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-156" data-mp="14iifrkugll1r">
                {product.images.map(image => <img key={image.src} src={image.src} alt={image.alt} className="w-full rounded-3xl shadow-lift" width={1200} height={1200} data-id="element-157" data-mp="1ghw4i3hxfesl" />)}
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}